import { CoordinatorService } from './coordinator.service';
import { TemplateRepository$ } from './template-repository$';

export type TemplateTag =
    | 'ratings'
    | 'tags'
    | 'icons'
    | 'project-detail'
    | 'biblio-article'
    | 'biblio-patent'
    | 'biblio-web'
    | 'external-web';


export class Template$ {
    repository$;

    // private _templateMap = new Map<string, any>()

    constructor(private coords: CoordinatorService) {
        this.repository$ = new TemplateRepository$(this.coords);
    }

    get(tp: TemplateTag) {
        if (tp.startsWith('biblio-')) return this.coords.config$.biblioTable(tp.slice(7));

        switch (tp) {
            case 'project-detail':
                return this.repository$.projectDetail;
            case 'ratings':
                return this.repository$.ratings;
            case 'tags':
                return this.repository$.tags;
            case 'external-web':
                return this.coords.externalWeb$.tableTemplate;
            default:
                return {};
        }
    }

    // get iconMap(): Map<string, string> {
    //     const mp = new Map<string, string>();
    //     Constants.icons.split('\n').forEach((ln) => {
    //         ln = ln.trim();
    //         if (ln.startsWith('#')) return;
    //         const tpl = ln.split(':').map((x) => x.trim());
    //         mp.set(tpl[0], tpl[1]);
    //     });
    //     return mp;
    // }
}
